import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  registration: {
    bankAccountRegistration: null,
    uiState: UiState.Idle
  },
  bankAccounts: null,
  uiState: UiState.Idle
};

const fetchBankAccountRegistrationRequest = draft => {
  draft.registration.uiState = UiState.Pending;
};

const fetchBankAccountRegistrationFailure = draft => {
  draft.registration.uiState = UiState.Failure;
};

const fetchBankAccountRegistrationSuccess = (draft, action) => {
  const {
    bankAccountRegistration
  } = action.payload;
  draft.registration = {
    bankAccountRegistration,
    uiState: UiState.Success
  };
};

const fetchBankAccountsRequest = draft => {
  draft.uiState = UiState.Pending;
};

const fetchBankAccountsFailure = draft => {
  draft.uiState = UiState.Failure;
};

const fetchBankAccountsSuccess = (draft, action) => {
  const {
    bankAccounts
  } = action.payload;
  draft.bankAccounts = bankAccounts;
  draft.uiState = UiState.Success;
};

const bankAccountSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchBankAccountRegistrationRequest,
    fetchBankAccountRegistrationFailure,
    fetchBankAccountRegistrationSuccess,
    fetchBankAccountsRequest,
    fetchBankAccountsFailure,
    fetchBankAccountsSuccess
  }
});
export const {
  actions
} = bankAccountSlice;
export const plug = {
  [stateName]: bankAccountSlice.reducer
};
export default bankAccountSlice.reducer;